/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Credentials_Permissions_Remove_Toast_Error_TitleInputs */

const es_components_credentials_permissions_remove_toast_error_title = /** @type {(inputs: Components_Credentials_Permissions_Remove_Toast_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al eliminar permiso`)
};

const en_components_credentials_permissions_remove_toast_error_title = /** @type {(inputs: Components_Credentials_Permissions_Remove_Toast_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to remove permission`)
};

/**
* | output |
* | --- |
* | "Failed to remove permission" |
*
* @param {Components_Credentials_Permissions_Remove_Toast_Error_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_credentials_permissions_remove_toast_error_title = /** @type {((inputs?: Components_Credentials_Permissions_Remove_Toast_Error_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Credentials_Permissions_Remove_Toast_Error_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_credentials_permissions_remove_toast_error_title(inputs)
	return en_components_credentials_permissions_remove_toast_error_title(inputs)
});
export { components_credentials_permissions_remove_toast_error_title as "components.credentials.permissions.remove.toast.error.title" }